/**************************************************
 * Nombre:       Tarjeta_Caracteristicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Caracteristicas = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                borderRadius: 1,
                border: 0.5,
                borderColor: '#ffffff50',
                background: 'linear-gradient(151deg, rgba(255, 255, 255, 0.10) 6.5%, rgba(45, 45, 45, 0.10) 59.48%)',
                backdropFilter: 'blur(5px)',
                color: '#fff',
                p: 2
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <img src={item.img} width={'80%'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{fontSize: 14, fontWeight: 600, textAlign: 'center'}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{fontSize: 12, fontWeight: 400, textAlign: 'center'}}>
                    {item.descripcion}
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Caracteristicas